import type { ExtractPropTypes, PropType } from 'vue'
import type { CalendarType               } from './calendar.type'
import type _Calendar from './calendar.vue'

export const sdCalendarProps = {
    modelValue     : {
        type: [String, Date, Number] as PropType<string | Date | number>,
        default: () => '',
    },
    width          : { type: [String, Number], default: '100%' },
    type           : { type: [String] as  PropType<CalendarType>, default: 'day' },
    firstDayOfWeek : { type: Number                                                             },
    defaultSelected: { type: [String, Array] as PropType<string | string[]>, default: () => ''  }, 
    cellStyle      : { type: Function                                                           },
} 

export type SdCalendarProps    = ExtractPropTypes<typeof sdCalendarProps>
export type SdCalendarInstance = InstanceType<typeof _Calendar>


